import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];
  static values = {
    message: String,
    position: String,
  };

  showTooltip(event) {
    if (this.messageValue) {
      this.contentTarget.innerHTML = this.messageValue;
      this.contentTarget.classList.add("block");
      this.contentTarget.classList.remove("hidden");

      // Position the tooltip relative to the trigger element
      this.positionTooltip(event.currentTarget);
    }
  }

  hideTooltip() {
    this.contentTarget.classList.add("hidden");
    this.contentTarget.classList.remove("block");
  }

  positionTooltip(triggerElement) {
    const triggerRect = triggerElement.getBoundingClientRect();
    const tooltipRect = this.contentTarget.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Calculate horizontal position (centered by default)
    let left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2;
    let top;

    // Calculate vertical position based on position parameter
    const position = this.positionValue || "top";
    if (position === "top") {
      top = triggerRect.top - tooltipRect.height - 8; // 8px gap above
    } else {
      top = triggerRect.bottom + 8; // 8px gap below
    }

    // Adjust horizontal position if tooltip would go off screen
    if (left < 8) {
      left = 8;
    } else if (left + tooltipRect.width > viewportWidth - 8) {
      left = viewportWidth - tooltipRect.width - 8;
    }

    // If tooltip would go above viewport and position is top, show it below instead
    if (position === "top" && top < 8) {
      top = triggerRect.bottom + 8;
    }
    // If tooltip would go below viewport and position is bottom, show it above instead
    else if (
      position === "bottom" &&
      top + tooltipRect.height > viewportHeight - 8
    ) {
      top = triggerRect.top - tooltipRect.height - 8;
    }

    // Apply the calculated position
    this.contentTarget.style.left = `${left}px`;
    this.contentTarget.style.top = `${top}px`;
  }
}
